var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../config/frontend/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/Brand/BrandArrows.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/Brand/BrandArrows.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(Object.prototype.hasOwnProperty.call(t_1, "svgSprite")) {
var t_4 = t_1.svgSprite;
} else {
cb(new Error("cannot import 'svgSprite'")); return;
}
context.setVariable("svgSprite", t_4);
output += "\n\n";
var macro_t_5 = runtime.makeMacro(
[], 
["brand"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("brand", Object.prototype.hasOwnProperty.call(kwargs, "brand") ? kwargs["brand"] : {});var t_6 = "";t_6 += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"prev")) {
t_6 += "\n        <div class=\"Brand-arrow Brand-arrow--prev\">\n            <a class=\"Brand-arrowLink u-Route\" href=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"prev")),"link"), env.opts.autoescape);
t_6 += "\">\n                <span class=\"Brand-arrowIcon\">\n                    ";
t_6 += runtime.suppressValue((lineno = 7, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "svgSprite"), "svgSprite", context, ["arrowAngle"])), env.opts.autoescape);
t_6 += "\n                </span>\n            </a>\n\n            <div class=\"Brand-arrowContent\">\n                <div class=\"Brand-arrowText\">\n                    <div class=\"Brand-arrowTitle\">";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"prev")),"title"), env.opts.autoescape);
t_6 += "</div>\n                    <div class=\"Brand-arrowSubtitle\">";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"prev")),"style"), env.opts.autoescape);
t_6 += "</div>\n                </div>\n\n                <div class=\"Brand-arrowImg\">\n                    <img src=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"prev")),"img")),"w30"), env.opts.autoescape);
t_6 += "\" srcset=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"prev")),"img")),"w60"), env.opts.autoescape);
t_6 += " 2x\" alt=\"\">\n                </div>\n            </div>\n        </div>\n    ";
;
}
t_6 += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"next")) {
t_6 += "\n        <div class=\"Brand-arrow Brand-arrow--next\">\n            <a class=\"Brand-arrowLink u-Route\" href=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"next")),"link"), env.opts.autoescape);
t_6 += "\">\n                <span class=\"Brand-arrowIcon\">\n                    ";
t_6 += runtime.suppressValue((lineno = 27, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "svgSprite"), "svgSprite", context, ["arrowAngle"])), env.opts.autoescape);
t_6 += "\n                </span>\n            </a>\n\n            <div class=\"Brand-arrowContent\">\n                <div class=\"Brand-arrowImg\">\n                    <img src=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"next")),"img")),"w30"), env.opts.autoescape);
t_6 += "\" srcset=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"next")),"img")),"w60"), env.opts.autoescape);
t_6 += " 2x\" alt=\"\">\n                </div>\n\n                <div class=\"Brand-arrowText\">\n                    <div class=\"Brand-arrowTitle\">";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"next")),"title"), env.opts.autoescape);
t_6 += "</div>\n                    <div class=\"Brand-arrowSubtitle\">";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "brand")),"next")),"style"), env.opts.autoescape);
t_6 += "</div>\n                </div>\n            </div>\n        </div>\n    ";
;
}
t_6 += "\n";
;
frame = callerFrame;
return new runtime.SafeString(t_6);
});
context.addExport("BrandArrows");
context.setVariable("BrandArrows", macro_t_5);
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "render") == true) {
output += "\n    ";
output += runtime.suppressValue((lineno = 46, colno = 18, runtime.callWrap(macro_t_5, "BrandArrows", context, [runtime.makeKeywordArgs({"brand": runtime.contextOrFrameLookup(context, frame, "brand")})])), env.opts.autoescape);
output += "\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/Brand/BrandArrows.jinja"] , dependencies)